export enum AuthAlertTypeEnum {
    emailSent,
    confirmed,
}